// import { useState } from "react";
// import { Grid } from "@mantine/core";
import { ProfileForm } from "src/modules/MyProfile/components/ProfileForm"

export default function MyProfile() {
  return <ProfileForm />;
}
